import { gql } from '@apollo/client'
import { HEALTH_DATA_REPORT_FIELDS } from '@screens/Nora/graphql/fragments/health_data_report.ts'

export const ALL_HEALTH_DATA_REPORTS = gql`
  ${HEALTH_DATA_REPORT_FIELDS}
  query allHealthDataReports(
    $sorts: [HealthDataReportSort!]
    $dynamicFilters: [HealthDataReportDynamicFilterItem!]
    $page: Int
    $perPage: Int
  ) {
    allHealthDataReports(
      sorts: $sorts
      dynamicFilters: $dynamicFilters
      page: $page
      perPage: $perPage
    ) {
      reports {
        ...HealthDataReportFields
      }
    }
  }
`
